export default __webpack_public_path__ + "static/media/twitter.def1bb8a.jfif";